var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCasa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "13.3,11.9 16,9 23.3,17 28,17 16,4 4,17 8,17 8,28 24,28 24,20 ",
    id: "id_101",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasa);
export default __webpack_public_path__ + "static/media/casa.e4c0370624eedca40b6d4bbabb45b20a.svg";
export { ForwardRef as ReactComponent };